import React, { Component } from 'react'

/** Route config */
import AppRoutes from './routes'

import { Provider } from 'react-redux'
import {configureStore} from './store';

const preloadState = window.__PRELOADED_STATE__CMS__;
delete window.__PRELOADED_STATE__CMS__;
const store = configureStore(preloadState);

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <AppRoutes />
      </Provider>
    )
  }
}

export default App
